module.exports = __webpack_public_path__ + "img/unavailable_shipping.a614632d.svg";